export const nativeBridge = {
    send(message) {
        const rn = window.ReactNativeWebView;

        if (rn?.postMessage) {
            rn.postMessage(JSON.stringify(message));
        }
    },
};
